module.exports = __webpack_public_path__ + "static/media/play.464516d1.svg";